import React from "react";
import { Card, CardBody, CardTitle, Row } from "reactstrap";
import LineStepped from "components/charts/LineStepped";

const CategoriesSteppedLine = ({
  chartClass = "chart-container",
  title,
  data,
  child,
}) => {
  let dataP = [];
  if (data.titles) {
    data.titles.forEach((element, index) => {
      dataP.push(
        <span>
          {index + 1}. {element}
          <br />
        </span>
      );
    });
  }

  return (
    <Card>
      <CardBody>
        <CardTitle>{title}</CardTitle>
        <div className={"mb-5"}>
          <LineStepped data={data.chartData} />
        </div>
        <Row>{child}</Row>
      </CardBody>
    </Card>
  );
};

export default CategoriesSteppedLine;
